module.exports = __webpack_public_path__ + "static/media/A6.955ed6ec.jpg";